import { SVGProps } from 'react';

export const IconLink = ({
  stroke = '#424242',
  width = '16',
  height = '16',
  ...otherProps
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 17 16'
      {...otherProps}
    >
      <path
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.1'
        d='M13.379 5.75v-3m0 0h-3m3 0-4.5 4.5m5.25 1.5v1.5a3.75 3.75 0 0 1-3.75 3.75h-4.5a3.75 3.75 0 0 1-3.75-3.75v-4.5A3.75 3.75 0 0 1 5.879 2h1.5'
      ></path>
    </svg>
  );
};
